import { render, staticRenderFns } from "./RGBPicker.vue?vue&type=template&id=29dc3e10&scoped=true&"
import script from "./RGBPicker.vue?vue&type=script&lang=js&"
export * from "./RGBPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dc3e10",
  null
  
)

export default component.exports